import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Inspection } from '../shared/interfaces';
import { InspectionService } from './inspection.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionResolver implements Resolve<Inspection> {
  constructor(
    private inspectionService: InspectionService,
    private router: Router,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const param = route.paramMap.get('id');

    if (param === 'add') {
      return null;
    }

    try {
      const id = parseInt(param, 10);
      return await this.inspectionService.get(id);
    } catch (e) {
      this.router.navigate(['/inspection']);
      return null;
    }
  }
}
